import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_CONTROLLER_GET_REQUEST: "AUDIT_CONTROLLER_GET_REQUEST",
    AUDIT_CONTROLLER_GET_FAILURE: "AUDIT_CONTROLLER_GET_FAILURE",
    AUDIT_CONTROLLER_GET_SUCCESS: "AUDIT_CONTROLLER_GET_SUCCESS",

    AUDIT_CONTROLLER_ITEM_SET: "AUDIT_CONTROLLER_ITEM_SET",
    AUDIT_CONTROLLER_SET: "AUDIT_CONTROLLERS_SET",
    AUDIT_CONTROLLER_MERGE: "AUDIT_CONTROLLER_MERGE",
    AUDIT_CONTROLLER_CLEAR: "AUDIT_CONTROLLER_CLEAR",

    AUDIT_CONTROLLER_POST_REQUEST: "AUDIT_CONTROLLER_POST_REQUEST",
    AUDIT_CONTROLLER_POST_FAILURE: "AUDIT_CONTROLLER_POST_FAILURE",
    AUDIT_CONTROLLER_POST_SUCCESS: "AUDIT_CONTROLLER_POST_SUCCESS",
    AUDIT_CONTROLLER_UPDATE_ASSET: "AUDIT_CONTROLLER_UPDATE_ASSET"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDIT_CONTROLLER_CLEAR
    }),
    itemSet: (auditControllers: any) => ({
        type: actionTypes.AUDIT_CONTROLLER_ITEM_SET,
        payload: { auditControllers }
    }),
    set: (auditControllers: Array<any>) => ({
        type: actionTypes.AUDIT_CONTROLLER_SET,
        payload: { auditControllers }
    }),
    getRequest: () => ({
        type: actionTypes.AUDIT_CONTROLLER_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_CONTROLLER_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_CONTROLLER_GET_FAILURE
    }),
    getSuccess: (auditControllers: any) => ({
        type: actionTypes.AUDIT_CONTROLLER_GET_SUCCESS,
        payload: { auditControllers }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.AUDIT_CONTROLLER_GET_FAILURE,
        error
    }),
    merge: (auditControllers: Array<any>) => ({
        type: actionTypes.AUDIT_CONTROLLER_MERGE,
        payload: { auditControllers }
    }),

    postRequest: (auditControllers: any) => ({
        type: actionTypes.AUDIT_CONTROLLER_POST_REQUEST,
        payload: { auditControllers },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_CONTROLLER_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_CONTROLLER_POST_FAILURE
    }),
    postSuccess: (auditControllers: any) => ({
        type: actionTypes.AUDIT_CONTROLLER_POST_SUCCESS,
        payload: { auditControllers }
    }),
    postFailure: (error) => ({
        type: actionTypes.AUDIT_CONTROLLER_POST_FAILURE,
        error
    }),
    updateAsset: (auditController) => ({
        type: actionTypes.AUDIT_CONTROLLER_UPDATE_ASSET,
        payload: { auditController }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
